import Chatbot from './botfront';
import React from "react";
import { createTheme } from '@mui/material/styles';
import { ThemeProvider } from "@emotion/react";

function App() {




  let theme = createTheme({
    palette: {
      primary: {
        main: '#FFE987',
      },
      secondary: {
        main: '#edf2ff',
      },
    },

 
  });



  return (
    <>
      <ThemeProvider theme={theme}>
        <Chatbot />
      </ThemeProvider>
    </>
  );
}



export default App;
